const moveableContentContainers = [
  ...document.querySelectorAll('[data-moveable-content-container]'),
];

const mediaQueriesMapping = moveableContentContainers.reduce((obj, container) => {
  const { moveableContentContainer, matchMedia } = container.dataset;

  obj[matchMedia] = obj[matchMedia] || {};
  obj[matchMedia][moveableContentContainer] = container;

  return obj;
}, {});

const move = (mediaQuery) => {
  const ids = Object.keys(mediaQueriesMapping[mediaQuery]);

  ids.forEach((id) => {
    const content = document.querySelector(`[data-moveable-content="${id}"]`);

    mediaQueriesMapping[mediaQuery][id].appendChild(content);
  });
};

const mediaQueries = Object.keys(mediaQueriesMapping);

const init = () => {
  mediaQueries.forEach((mediaQuery) => {
    const matchMedia = window.matchMedia(mediaQuery);

    if (matchMedia.matches) move(mediaQuery);

    matchMedia.onchange = (e) => {
      if (e.matches) move(mediaQuery);
    };
  });
};

export default init;
